import { CommitmentSourcesService_commitmentSourcesServiceGetStops } from '@festina/life-general-types/life/hooks/CommitmentSourcesStopsService_commitmentSourcesServiceGetStops'

export const useFetchCommitmentStopHistory =
  CommitmentSourcesService_commitmentSourcesServiceGetStops.useQuery
